import { com, kotlin } from '@eidu/web'
import KtList = kotlin.collections.KtList
import Page = com.eidu.sharedlib.form.definition.Page
import decodeFormContentFromYaml = com.eidu.sharedlib.form.decodeFormContentFromYaml

export const newEmptyFormContent = (): KtList<Page> =>
  KtList.fromJsArray([new Page('Untitled page', KtList.fromJsArray([]), `page_${Date.now()}`, null)])

export type DecodedFormContent = { pages: KtList<Page>; error?: string }

/**
 * Decodes form YAML for display in the editor. A blank payload yields a fresh single page; an undecodable payload
 * yields an empty form plus an error message, so a corrupt asset.resource surfaces an error rather than crashing.
 */
export const safeDecodeFormContentYaml = (yaml: string | undefined): DecodedFormContent => {
  if (!yaml || yaml.trim().length === 0) return { pages: newEmptyFormContent() }
  try {
    return { pages: decodeFormContentFromYaml(yaml) }
  } catch (e) {
    return { pages: newEmptyFormContent(), error: e instanceof Error ? e.message : 'Invalid form YAML' }
  }
}
